import { render, staticRenderFns } from "./ProcessOrder.vue?vue&type=template&id=3fd1e4f8&"
import script from "./ProcessOrder.vue?vue&type=script&lang=js&"
export * from "./ProcessOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports